import { downloadBlob, getJson, postForFile } from './batch3Api';

export { downloadBlob };

// ── Revenue splitter ─────────────────────────────────────────────────────────

export interface RevenueSplitSummary {
  summary: string;
  files: string[];
}

export function splitRevenue(file: File) {
  const form = new FormData();
  form.append('input_file', file);
  return postForFile<RevenueSplitSummary>('/revenue-splitter/split', form, 'Revenue_Split.zip', 'Splitting failed');
}

// ── Payroll match ────────────────────────────────────────────────────────────

export interface PayrollMatchSummary {
  exact: number;
  not_exact: number;
  unmatched: number;
  unreconciled: number;
}

export function matchPayroll(payroll: File, netWages: File, threshold: number) {
  const form = new FormData();
  form.append('payroll_file', payroll);
  form.append('net_wages_file', netWages);
  form.append('options', JSON.stringify({ threshold }));
  return postForFile<PayrollMatchSummary>('/payroll-match/match', form, 'Matched_Wages.xlsx', 'Matching failed');
}

// ── Unmerge & realign ────────────────────────────────────────────────────────

export interface UnmergeLayout {
  key: string;
  label: string;
}

export interface UnmergeFileReport {
  file: string;
  status: 'ok' | 'skip' | 'error';
  message?: string;
  sheets?: {
    sheet: string;
    layout: string;
    layout_label: string;
    unmerged: number;
    moved: number;
    collisions: number;
  }[];
}

export interface UnmergeSummary {
  cleaned: number;
  total: number;
  files: UnmergeFileReport[];
}

export async function fetchUnmergeLayouts(): Promise<UnmergeLayout[]> {
  const data = await getJson<{ layouts: UnmergeLayout[] }>('/unmerge-realign/layouts', 'Could not load the layouts');
  return data.layouts;
}

export function cleanReports(files: File[], forcedLayout: string | null) {
  const form = new FormData();
  files.forEach((f) => form.append('input_files', f));
  form.append('options', JSON.stringify({ forced_layout: forcedLayout }));
  return postForFile<UnmergeSummary>('/unmerge-realign/clean', form, 'cleaned_reports.zip', 'Cleaning failed');
}

// ── Notes & queries ──────────────────────────────────────────────────────────

export interface NotesQueriesSummary {
  mapping_errors: string[];
  log: string;
}

export function generateNotesQueries(transactions: File, mapping: File, yearEnd: string) {
  const form = new FormData();
  form.append('transactions_file', transactions);
  form.append('mapping_file', mapping);
  form.append('options', JSON.stringify({ year_end: yearEnd.trim() || null }));
  return postForFile<NotesQueriesSummary>('/notes-queries/generate', form, 'Notes_Queries.xlsx', 'Generating the workbook failed');
}
